import {Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from '../../environments/environment';
import {ApiCapaService} from '../_services/apiCapa.service';
import {User} from '../_models/user.model';
import {KeycloakService} from 'keycloak-angular';


@Component({ templateUrl: 'capa.component.html' })
export class CapaComponent implements OnInit {
  md5 = require('js-md5');

  loginForm: FormGroup;
  error: boolean;

  constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private apiCapaService: ApiCapaService,
      private oauthService: OAuthService,
      private keycloakService: KeycloakService
  ) { }

  ngOnInit() {

    this.createLoginForm();

    // Si un utilisateur azure est connecté
    if (localStorage.getItem('currentUser') != null) {
      const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
      // On vérifie si il est admin capa sur clhub
      if (this.keycloakService.isUserInRole('clhub-admin-capa')) {
        localStorage.setItem('isCapaAdmin', 'true');
        this.router.navigate(['capa/license/list']);
      }
      // Si pas d'utilisateur azure connecté, on vérifie si il est déja connecté en tant que client sur capa clhub
    } else if (localStorage.getItem('capaAccount') != null) {
        this.router.navigate(['capa/result/list', 'account']);
      // dernier cas, pas d'utilisateur azure, pas non plus d'utilisateur capa, alors connexion capa
    } else {
      this.initializeCapaLogin();
    }
  }

  initializeCapaLogin() {
    localStorage.setItem('isCapaAdmin', 'false');
    this.oauthService.tokenEndpoint = environment.keycloakIssuer + '/protocol/openid-connect/token';
    // Url with user info endpoint
    // This endpont is described by OIDC and provides data about the loggin user
    // This sample uses it, because we don't get an id_token when we use the password flow
    // If you don't want this lib to fetch data about the user (e. g. id, name, email) you can skip this line
    this.oauthService.userinfoEndpoint = environment.keycloakIssuer + '/protocol/openid-connect/userinfo';

    // The SPA's id. Register SPA with this id at the auth-server
    this.oauthService.clientId = 'clhub-client';
    this.oauthService.redirectUri = environment.capaKeycloakRedirectURL;
    // set the scope for the permissions the client should request
    this.oauthService.scope = 'openid';
    this.oauthService.oidc = false;

    this.oauthService.fetchTokenUsingPasswordFlowAndLoadUserProfile('cotral_apps', 'Tén@6T').then((resp) => {}).then(() => {
      // Using the loaded user data
      const claims = this.oauthService.getIdentityClaims();
    });
  }

  createLoginForm() {
    const emailRegex: RegExp = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$');

    this.loginForm = this.formBuilder.group({
      // Pattern validator because validator.email is not working correctly
      email: ['', [Validators.required, Validators.pattern(emailRegex)]],
      password: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.apiCapaService.post(
        'Accounts/filtered-list',
        {
          Email: this.loginForm.value.email.toLowerCase(),
          Password: this.md5(this.loginForm.value.password)
        }
    ).subscribe(result => {
      // Si on a un unique résultat c'est bon, go
      if (result && result['infos'][0]['count'] === 1) {
        localStorage.setItem('capaAccount', JSON.stringify(result['entities'][0]));
        this.router.navigate(['capa/result/list', 'account']);
      } else {
        this.error = true;
      }
    });
  }

  goToAccountCreation() {
    this.router.navigate(['capa/create-account']);
  }
}
